import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountSelectors } from '../../../stores-modules/account-store/account.selectors';
import { filter, take } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AccountManagementModule } from '@serviceos-ng/shared-modules';
import { SosCoreConfig } from '@serviceos-ng/core';
import { DeviceDetectorService } from 'ngx-device-detector';

declare global {
    interface Window {
        analytics: any;
    }
}

@Injectable({ providedIn: 'root' })
export class SegmentService {
    constructor(
        private store: Store,
        private _localStorageService: LocalStorageService,
        private config: SosCoreConfig,
        private _deviceDetector: DeviceDetectorService
    ) {}

    private loaded = false;

    load(writeKey: string) {
        if (this.loaded || (window as any).analytics) return;

        (function () {
            const analytics = ((window as any).analytics =
                (window as any).analytics || []);
            if (!analytics.initialize) {
                analytics.invoked = true;
                analytics.methods = [
                    'trackSubmit',
                    'trackClick',
                    'trackLink',
                    'trackForm',
                    'pageview',
                    'identify',
                    'reset',
                    'group',
                    'track',
                    'ready',
                    'alias',
                    'debug',
                    'page',
                    'once',
                    'off',
                    'on',
                ];
                analytics.factory = function (method: string) {
                    return function () {
                        const args = Array.prototype.slice.call(arguments);
                        args.unshift(method);
                        analytics.push(args);
                        return analytics;
                    };
                };
                for (let i = 0; i < analytics.methods.length; i++) {
                    const key = analytics.methods[i];
                    analytics[key] = analytics.factory(key);
                }
                analytics.load = function (key: string) {
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src =
                        'https://cdn.segment.com/analytics.js/v1/' +
                        key +
                        '/analytics.min.js';
                    const first = document.getElementsByTagName('script')[0];
                    first.parentNode?.insertBefore(script, first);
                };
                analytics.SNIPPET_VERSION = '4.13.2';
                analytics.load(writeKey);
            }
        })();

        this.loaded = true;
    }

    identify(
        event: 'login_success' | 'created_account',
        type:
            | 'microsoft'
            | 'facebook'
            | 'oauth2'
            | 'google'
            | 'apple'
            | 'azure'
            | 'email'
    ) {
        let sendData: any = {};

        this.store
            .select(AccountSelectors.account)
            .pipe(
                filter((account) => !!account), // wait until account is not null
                take(1) // fire only once, no memory leak
            )
            .subscribe((account) => {

                let currentProfile = '';

                if (
                    this._localStorageService.getItem('selected_profile') &&
                    this._localStorageService.getItem('selected_profile') !==
                        'undefined'
                ) {
                    currentProfile = this._localStorageService.getItem(
                        'selected_profile'
                    );
                } else {
                    currentProfile = window?.obfOptions?.profile_id
                        ? window.obfOptions.profile_id
                        : this.config.profile_id + '';
                }

                sendData = {
                    user_id: account.id,
                    category: 'Client',
                    layer: 'Web',
                    path: window?.location?.pathname,
                    hostname: window?.location?.hostname,
                    market_id: currentProfile,
                    method: type,
                    was_referred: null,
                    device_identifier: this._deviceDetector?.userAgent,
                    version: '',
                    traits: '',
                };

                // event: event,
                // loginType: type,
                // userId: account.id,
                // membership: account.membership ? 'regular' : 'regular',
                // username: account.username,
                // type: 'logged_in'

                (window as any).analytics?.identify(event, sendData);
            });
    }

    track(event: string, properties?: object) {
        (window as any).analytics?.track(event, properties);
    }

    page(name?: string, properties?: object) {
        (window as any).analytics?.page(name, properties);
    }

    extendData(data) {
        return data;
    }
}
